<template>
    <v-layout row wrap justify-center align-center>
        <v-flex xs12 sm10 md8 lg5 class="text-xs-center mx-3 mb-3">
            <v-card>
                <v-card-text>
                    <v-text-field label="Withdraw fee (%)" placeholder="ค่าทำเนียมการถอนเงิน" mask="###" hide-details></v-text-field>
                    <v-text-field label="Order fee (%)" mask="###" placeholder="ค่าทำเนียมที่ไรเดอร์ถูกหักต่อออเดอร์" hide-details></v-text-field>
                </v-card-text>
            </v-card>

            <v-card class="my-3">
                <v-card-text>
                    <v-text-field label="Fee (%)" mask="###" hide-details></v-text-field>
                    <ul>
                        <li><v-text-field label="Fee (%)" mask="###" hide-details></v-text-field></li>
                        <li><v-text-field label="Fee (%)" mask="###" hide-details></v-text-field></li>
                        <li><v-text-field label="Fee (%)" mask="###" hide-details></v-text-field></li>
                    </ul>
                </v-card-text>
            </v-card>

             <v-card>
                <v-card-text>
                    <v-text-field label="Fee (%)" mask="###" hide-details></v-text-field>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" class="black--text">submit</v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-flex>
        <!-- <v-flex xs12 sm10 md8 class="text-xs-center mx-3 mb-3">
            <v-card color="secondary">
                <v-card-text class="note-withdraw">
                    เมนู "Withdraw Cash" ใช้สำหรับการส่งคำร้องเพื่อขอถอนเงิน (cash) ของ rider ออกจากระบบ 
                    เมื่อส่งคำร้องเรียบร้อยแล้ว สามารถอนุมัติได้ในเมนู "Money > Request cash" 
                    <div class="red--text">หมายเหตุ : การถอนเงินมีการคิดค่าธรรมเนียมในการโอนเงิน สามารถแก้ไขได้ในเมนู "Setting > General"</div> 
                </v-card-text>
            </v-card>
        </v-flex> -->
    </v-layout>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

